/**
 * Converts a date string or Date object to ISO 8601 format.
 */
export const formatDateToISO = (
  date: string | Date | null | undefined,
): string | null => {
  if (!date) {
    return null;
  }

  try {
    if (date instanceof Date) {
      return date.toISOString();
    }

    if (typeof date !== 'string') {
      return null;
    }

    const normalizedDate = date.trim();
    if (!normalizedDate) {
      return null;
    }

    let dateObj: Date;

    if (normalizedDate.match(/^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/)) {
      dateObj = new Date(normalizedDate.replace(/\//g, '-'));
    } else if (normalizedDate.match(/^\d{1,2}[/-]\d{1,2}[/-]\d{4}$/)) {
      const parts = normalizedDate.split(/[/-]/);
      const first = parseInt(parts[0], 10);
      const second = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);

      if (Number.isNaN(first) || Number.isNaN(second) || Number.isNaN(year)) {
        return null;
      }

      if (first > 12) {
        dateObj = new Date(year, second - 1, first);
      } else {
        dateObj = new Date(year, first - 1, second);
      }
    } else {
      dateObj = new Date(normalizedDate);
    }

    if (Number.isNaN(dateObj.getTime())) {
      console.warn('Invalid date format:', date);
      return null;
    }

    return dateObj.toISOString();
  } catch (error) {
    console.error('Error converting date to ISO format:', error);
    return null;
  }
};

export default formatDateToISO;
